import React from "react";
import PropTypes from "prop-types";
import { AlertTriangle } from "lucide-react";

function ErrorFallback({ error, resetErrorBoundary = () => {} }) {
  const isDev =
    (import.meta?.env?.DEV ?? false) ||
    (import.meta?.env?.MODE !== "production");

  const errorMessage =
    error instanceof Error ? error.message : error ? String(error) : "";

  const handleTryAgain = () => {
    resetErrorBoundary();
  };

  const handleGoHome = () => {
    // Navigate using browser since fallback may be outside router
    window.location.assign("/");
  };

  return (
    <main
      role="alert"
      aria-labelledby="error-title"
      className="d-flex flex-column align-center justify-center w-100 h-100 p-2"
    >
      <div className="bg-gray-50 card-shadow rounded-lg p-3 max-w-800 w-100 transition-smooth">
        <div className="d-flex flex-column align-center">
          <AlertTriangle
            aria-hidden="true"
            className="text-warning"
            size={56}
            strokeWidth={1.8}
          />

          <h1 id="error-title" className="text-xl fw-bold text-primary mt-2">
            Something went wrong
          </h1>

          <p className="text-md lh-14 text-muted mb-2 mt-1">
            It looks like something broke on our side. You can try again, or
            head back to the home page.
          </p>

          <div className="d-flex flex-wrap justify-center gap-2 mt-2">
            <button
              type="button"
              onClick={handleTryAgain}
              disabled={!resetErrorBoundary}
              className="bg-gradient-primary rounded-md btn-hover-glow py-1 px-2 cursor-pointer transition-smooth"
            >
              <span className="text-primary fw-semibold">Try Again</span>
            </button>

            <button
              type="button"
              onClick={handleGoHome}
              className="bg-gray-100 rounded-md btn-hover-glow py-1 px-2 cursor-pointer transition-smooth"
            >
              <span className="text-primary fw-semibold">Go Home</span>
            </button>
          </div>
        </div>

        {isDev && errorMessage ? (
          <div className="mt-2 bg-gray-100 rounded-md p-2">
            <div className="fw-semibold text-sm text-muted mb-1">
              Error details
            </div>
            <pre className="text-sm text-muted whitespace-pre-line overflow-x-auto m-0">
              {errorMessage}
            </pre>
          </div>
        ) : null}
      </div>
    </main>
  );
}

ErrorFallback.propTypes = {
  error: PropTypes.any,
  resetErrorBoundary: PropTypes.func, // or .isRequired if always provided
};

export default ErrorFallback;